/* eslint-disable class-methods-use-this,react/jsx-no-bind */
import { Component, FC } from 'react';
import Slider from 'react-slick';
import { toast } from 'react-toastify';

import { TourTypeURL } from '@/_models/Tour';
import { LeadCategory } from '@/_models/TourLead';
import LoadingProgress from '@/components/common/LoadingProgress';
import Iframe from '../../../units/Iframe';
import { CustomCookieConsent } from '../../common/CookieConsent';
import * as all from '../../util/all';
import { fetchData } from '../../util/all';
import { downloadAllImages, downloadImage } from '../helper';
import FloorPlan from '../overview/floorPlan/FloorPlan';
import Map from '../overview/map/Map';
import Summary from '../overview/summary/Summary';
import { DownloadAll } from '../style';
import ReactModal from 'react-modal';

type ModalProps = {
  children: any;
  isOpen: boolean;
  id?: string;
  ariaHideApp?: boolean;
  style?: ReactModal.Styles;
  appElement?: HTMLElement;
  className?: string;
  onRequestClose: () => void;
  overlayClassName?: string;
  contentLabel?: string;
};

const Modal: FC<ModalProps> = ({ children, ...props }) => (
  <ReactModal {...props}>{children}</ReactModal>
);

export default class ClassicPublicAsset extends Component<any, any> {
  root: any;

  tour: any;

  map: any;

  amenities: any;

  floorPlans: any;

  contact: any;

  matterTour: any;

  constructor(props: any) {
    super(props);
    this.state = {
      tour: null,
      play: false,
      menuOpen: false,
      videoOpen: false,
      galleryOpen: false,
      menuOpened: false,
      selectedPlan: null,
      readMore: false,
      images: [],
      newLead: {
        name: null,
        email: null,
        phone: null,
        message: null,
      },
      downloading: false,
      imageLoading: false,
    };
    this.toggleGallery = this.toggleGallery.bind(this);
  }

  componentDidMount() {
    const { tour } = this.props;
    this.setState({
      tour,
      selectedPlan: tour.floorPlans.length > 0 ? tour.floorPlans[0].url : null,
    });
    const clicked = this.props.menuItemClickedBookingPage;
    if (clicked) {
      if (clicked === 'gallery') {
        this.toggleGallery();
      } else {
        setTimeout(this.scrollTo.bind(this, clicked), 1000);
      }
    }
  }

  toggleMenu() {
    this.setState({ menuOpened: true, menuOpen: !this.state.menuOpen });
  }

  toggleVideo() {
    this.setState({
      videoOpen: !this.state.videoOpen,
      menuOpen: false,
      galleryOpen: false,
    });
  }

  toggleGallery() {
    const tour = this.state.tour ? this.state.tour : this.props.tour;
    if (this.state.images.length === 0) {
      all
        .fetchData('public/getAllTourImages', 'POST', {
          id: tour.id,
        })
        .then(async (data: any) => {
          if (!data.images) {
            toast.error("Couldn't load images");
          } else {
            const images = data.images.map(
              (img: any) => `${this.props.reactAws}/tours/${tour.id}/images/${img.url}`,
            );
            this.setState({ images });
          }
        })
        .catch((err) => {
          console.error(err.message);
        });
    }
    this.setState({
      galleryOpen: !this.state.galleryOpen,
      menuOpen: false,
      videoOpen: false,
    });
  }

  scrollTo(to: any) {
    to.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({ menuOpen: false });
  }

  editLead(event: any) {
    const { name } = event.target;
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    const { newLead } = this.state;
    newLead[name] = value;
    this.setState({ newLead });
  }

  async sendLead() {
    const params = Object.assign(this.state.newLead, {
      tour: this.state.tour.title,
      userId: this.state.tour.userId,
      link: window.location.href,
      clientId: this.state.tour?.client?.id,
    });
    const { tourEmail, client, id } = this.state.tour;
    try {
      await fetchData('public/sendEmail', 'POST', {
        to: (tourEmail && tourEmail.assertGetInTouch) || (client && client.email),
        params,
      });
      toast.success('E-Mail sent');
      this.setState({
        newLead: {
          name: null,
          email: null,
          phone: null,
          message: null,
        },
      });
      await fetchData('public/setTourLead', 'POST', {
        name: params.name,
        email: params.email,
        phone: params.phone,
        category: LeadCategory.AssertTouchForm,
        tourId: id,
      });
    } catch (err) {
      console.error(err.message);
    }
  }

  switchPlan(url: string, index: number) {
    const { tour } = this.state;
    tour.floorPlans.map((plan: any) => {
      plan.selected = false;
      return plan;
    });
    tour.floorPlans[index].selected = true;
    this.setState({ tour, selectedPlan: url });
  }

  async downloadCurrentImage(url: string) {
    this.setState({ imageLoading: true });
    await downloadImage(url, this.state.tour);
    this.setState({ imageLoading: false });
  }

  async downloadAll() {
    const { images } = this.state;
    this.setState({
      downloading: true,
    });

    await downloadAllImages(images, this.state.tour);
    this.setState({
      downloading: false,
    });
  }

  public render() {
    const { tour, downloading, imageLoading } = this.state;
    let logo;
    let iframeSrcPrefixByTourType;
    let summaryOn = false;
    let floorPlansOn = false;
    const { whitelabel } = this.props;
    const fbAppId = tour?.client?.fbAppId || tour?.user?.fbAppId;

    if (tour) {
      summaryOn = tour?.summary?.length > 0;
      floorPlansOn = tour.floorPlansEnabled && !!tour.floorPlans.length;

      logo =
        tour.client && !tour.unbranded && tour.client.logo
          ? `${this.props.reactAws}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`
          : null;
      iframeSrcPrefixByTourType = TourTypeURL[tour.mode];
    }

    if (this.state.loading || !tour) {
      return <LoadingProgress />;
    }

    return (
      <div
        id="public-asset-root"
        ref={(el) => {
          this.root = el;
        }}
        className={tour.client?.rtl ? 'rtl' : 'ltr'}
      >
        <Modal
          className="popup"
          isOpen={this.state.videoOpen}
          onRequestClose={this.toggleVideo.bind(this)}
          appElement={this.root}
        >
          <a onClick={this.toggleVideo.bind(this)}>
            <i className="fa fa-times" />
          </a>
          {tour.videoUrl && (
            <Iframe
              logoSrc={whitelabel?.logo}
              src={all.getVideoLink(tour.videoUrl)}
              allowFullscreen
            />
          )}
        </Modal>

        <Modal
          className="popup"
          isOpen={this.state.galleryOpen}
          onRequestClose={this.toggleGallery.bind(this)}
          appElement={this.root}
        >
          <a onClick={this.toggleGallery.bind(this)}>
            <i className="fa fa-times" />
          </a>
          {tour.client && tour.client.logo && (
            <img
              alt=""
              className={tour.client.widthLogo ? 'logo width' : 'logo'}
              src={`${this.props.reactAws}/clients/${tour.client.id}/logo.png${all.getVersion(tour.client.updatedAt)}`}
            />
          )}

          {tour.client && tour.client.watermark && (
            <img
              alt=""
              className="watermark"
              src={`${this.props.reactAws}/clients/${tour.client.id}/watermark.png${all.getVersion(tour.client.updatedAt)}`}
            />
          )}
          <Slider
            className="gallery-slider"
            infinite={false}
            arrows
            autoplay={false}
            dots={false}
            fade={false}
          >
            {this.state.images.map((image: string, i: number) => (
              <div key={i}>
                <div
                  className="bg"
                  style={{
                    backgroundImage: `url(${image})`,
                  }}
                >
                  <DownloadAll onClick={this.downloadAll.bind(this)}>
                    {downloading ? (
                      <i className="fas fa-spinner fa-spin" />
                    ) : (
                      <i className="fas fa-angle-double-down" />
                    )}
                  </DownloadAll>
                  {imageLoading ? (
                    <i className="download fas fa-spinner fa-spin" />
                  ) : (
                    <i
                      onClick={this.downloadCurrentImage.bind(this, image)}
                      className="download fas fa-cloud-download-alt"
                    />
                  )}
                </div>
              </div>
            ))}
          </Slider>
        </Modal>

        {/* eslint-disable-next-line no-nested-ternary */}
        <div
          className={
            this.state.menuOpen
              ? 'buttonBg open'
              : this.state.menuOpened
                ? 'buttonBg'
                : 'buttonBg animation'
          }
          onClick={this.toggleMenu.bind(this)}
        >
          <button
            className={
              this.state.menuOpen
                ? 'hamburger hamburger--spin is-active'
                : 'hamburger hamburger--spin'
            }
            type="button"
          >
            <span className="hamburger-box">
              <span className="hamburger-inner" />
            </span>
          </button>
          <span>{tour.translation?.menu}</span>
        </div>
        <nav className={this.state.menuOpen ? 'open' : ''}>
          {tour.address && (
            <a onClick={this.scrollTo.bind(this, this.map)}>{tour.translation?.map}</a>
          )}
          {tour.videoUrl && (
            <a onClick={this.toggleVideo.bind(this)}>{tour.translation?.playVideo}</a>
          )}
          <a onClick={this.toggleGallery.bind(this)}>{tour.translation?.gallery}</a>
          {floorPlansOn && (
            <a onClick={this.scrollTo.bind(this, this.floorPlans)}>
              {tour.translation?.floorPlans}
            </a>
          )}
          {tour.amenities && (
            <a onClick={this.scrollTo.bind(this, this.amenities)}>{tour.translation?.amenities}</a>
          )}
          <a onClick={this.scrollTo.bind(this, this.matterTour)}>{tour.translation?.threeDTour}</a>
          {!tour.unbranded && (
            <a onClick={this.scrollTo.bind(this, this.contact)}>{tour.translation?.contact}</a>
          )}
        </nav>
        <div className={this.state.menuOpen ? 'content open' : 'content'}>
          <div className="intro">
            <div className="container">
              {logo && (
                <img alt="" className={tour.client?.widthLogo ? 'logo width' : 'logo'} src={logo} />
              )}
              <div
                className="info-container"
                style={{
                  bottom: !tour.address ? '70px' : ' 130px',
                }}
              >
                <div className="title-container">
                  <div className="color-container" />
                  <h1>{tour.title}</h1>
                </div>
                {tour.address && <p className="info">{tour.address} </p>}
                {(tour.beds || tour.showers || tour.cars || tour.accomodation || tour.size) && (
                  <p className="info" style={{ textIndent: '0', padding: 0 }}>
                    <div className="amenetis">
                      {tour.beds && (
                        <span>
                          <i className="fas fa-bed" /> {tour.beds}
                        </span>
                      )}
                      {tour.showers && (
                        <span>
                          <i className="fas fa-bath" /> {tour.showers}
                        </span>
                      )}
                      {tour.cars && (
                        <span>
                          <i className="fas fa-car" /> {tour.cars}
                        </span>
                      )}
                      {tour.accomodation && (
                        <span>
                          <i className="fas fa-home" /> {tour.accomodation}
                        </span>
                      )}
                      {tour.size && (
                        <span>
                          <i className="fas fa-ruler-combined" /> {tour.size}{' '}
                          {tour.unitSystem === 'metric' ? 'm2' : 'ft'}
                        </span>
                      )}
                      {tour.price && (
                        <span>
                          <i className="fas fa-money-bill-wave" /> {tour.price}
                        </span>
                      )}
                    </div>
                  </p>
                )}
                {tour.videoUrl && (
                  <a className="square-button video-active" onClick={this.toggleVideo.bind(this)}>
                    <i className="fas fa-video" />
                    {tour.translation?.playVideo}
                  </a>
                )}

                {tour.images.length > 0 && (
                  <a
                    className={
                      tour.videoUrl
                        ? 'square-button video-active gallery-button'
                        : 'square-button gallery-button'
                    }
                    onClick={this.toggleGallery.bind(this)}
                  >
                    <i className="fas fa-images" />
                    {tour.translation?.gallery}
                  </a>
                )}
              </div>
            </div>

            <Slider
              className="main-slider"
              infinite
              arrows={false}
              autoplay
              dots={false}
              fade
              autoplaySpeed={8000}
              speed={3000}
              cssEase="cubic-bezier(0.7, 0, 0.3, 1)"
            >
              {tour.images.slice(0, 7).map((image: any, i: number) => (
                <div key={i}>
                  <div
                    className="bg"
                    style={{
                      backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${image.url})`,
                    }}
                  />
                </div>
              ))}
            </Slider>
          </div>
          {summaryOn && floorPlansOn && (
            <div className="overview h-610">
              <div className="container m-0 w-100 h-100">
                <div className="row h-100">
                  <div className="col-6 p-0 h-100">
                    <div
                      className="row w-100 m-0"
                      style={{
                        height: this.state.readMore ? '60%' : '30%',
                      }}
                    >
                      <Summary tour={tour} />
                    </div>
                    <div
                      className="row w-100 m-0"
                      ref={(el: any) => {
                        this.map = el;
                      }}
                      style={{
                        height: this.state.readMore ? '40%' : '70%',
                      }}
                    >
                      {tour.address && (
                        <Map
                          logo={whitelabel?.logo}
                          address={tour.address}
                          googleKey={this.props.googleKey}
                        />
                      )}
                    </div>
                  </div>
                  <div
                    className="col-6 p-0 h-100"
                    ref={(el: any) => {
                      this.floorPlans = el;
                    }}
                  >
                    <FloorPlan
                      tour={tour}
                      switchPlan={this.switchPlan.bind(this)}
                      selectedPlan={this.state.selectedPlan}
                      imgLong
                      className="h-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {summaryOn !== floorPlansOn && (
            <div className="overview h-400">
              <div className="container m-0 w-100 h-100">
                <div className="row h-100">
                  <div className="col-6 p-0 h-100">
                    {summaryOn && (
                      <div className="row h-100 w-100 m-0">
                        <Summary tour={tour} />
                      </div>
                    )}
                    {floorPlansOn && (
                      <div
                        className="row h-100 w-100 m-0"
                        ref={(el: any) => {
                          this.floorPlans = el;
                        }}
                      >
                        <FloorPlan
                          tour={tour}
                          switchPlan={this.switchPlan.bind(this)}
                          selectedPlan={this.state.selectedPlan}
                          imgLong={false}
                          className="h-100 w-100"
                        />
                      </div>
                    )}
                  </div>
                  <div
                    className="col-6 p-0 h-100"
                    ref={(el: any) => {
                      this.map = el;
                    }}
                  >
                    {tour.address && (
                      <Map
                        logo={whitelabel?.logo}
                        address={tour.address}
                        googleKey={this.props.googleKey}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {!summaryOn && !floorPlansOn && (
            <div className="overview h-400">
              <div className="container m-0 w-100 h-100">
                <div
                  className="row h-100"
                  ref={(el: any) => {
                    this.map = el;
                  }}
                >
                  {tour.address && (
                    <Map
                      logo={whitelabel?.logo}
                      address={tour.address}
                      googleKey={this.props.googleKey}
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          <div
            className="section tour"
            ref={(el) => {
              this.matterTour = el;
            }}
          >
            <div className="clearfix">
              <h2>{tour.translation?.threeDTour}</h2>
            </div>
            <div className="inner">
              {!this.state.play && (
                <div className="overlay">
                  <div className="text">
                    <img
                      alt=""
                      src="/images/play.svg"
                      onClick={() => {
                        this.setState({ play: true });
                      }}
                    />
                  </div>
                </div>
              )}
              {!this.state.play && (
                <div
                  className="bg"
                  style={{
                    backgroundImage: `url(${this.props.reactAws}/tours/${tour.id}/images/${tour.mainImage})`,
                  }}
                />
              )}
              {this.state.play && (
                <Iframe
                  logoSrc={whitelabel?.logo}
                  src={`/${iframeSrcPrefixByTourType}/${tour.slug}?messenger=0`}
                  allowFullscreen
                />
              )}
            </div>
          </div>

          {!tour.unbranded && (
            <div
              className="section contact"
              ref={(el) => {
                this.contact = el;
              }}
            >
              <div className="container">
                {tour.contactForm && (
                  <div className="left">
                    <h2>{tour.translation?.getInTouch}</h2>
                    <form>
                      <input
                        type="text"
                        placeholder={tour.translation?.name}
                        name="name"
                        value={this.state.newLead.name ? this.state.newLead.name : ''}
                        onChange={this.editLead.bind(this)}
                      />
                      <input
                        type="text"
                        placeholder={tour.translation?.email}
                        name="email"
                        value={this.state.newLead.email ? this.state.newLead.email : ''}
                        onChange={this.editLead.bind(this)}
                      />
                      <input
                        type="text"
                        placeholder={tour.translation?.phone}
                        name="phone"
                        value={this.state.newLead.phone ? this.state.newLead.phone : ''}
                        onChange={this.editLead.bind(this)}
                      />
                      <input
                        type="text"
                        placeholder={tour.translation?.message}
                        name="message"
                        value={this.state.newLead.message ? this.state.newLead.message : ''}
                        onChange={this.editLead.bind(this)}
                      />
                      <a className="square-button" onClick={this.sendLead.bind(this)}>
                        {tour.translation?.submit}
                      </a>
                    </form>
                  </div>
                )}
              </div>
              <div className="right" style={!tour.contactForm ? { width: '100%' } : {}}>
                {tour.client && (
                  <div className="lg">
                    {logo && <img src={logo} alt="" />}
                    {tour.client.facebook && (
                      <a href={tour.client.facebook} rel="noreferrer" target="_blank">
                        <i className="fab fa-facebook" />
                      </a>
                    )}
                    {tour.client.instagram && (
                      <a href={tour.client.instagram} rel="noreferrer" target="_blank">
                        <i className="fab fa-instagram" />
                      </a>
                    )}
                    {tour.client.linkedin && (
                      <a href={tour.client.linkedin} rel="noreferrer" target="_blank">
                        <i className="fab fa-linkedin" />
                      </a>
                    )}
                    {tour.client.twitter && (
                      <a href={tour.client.twitter} rel="noreferrer" target="_blank">
                        <i className="fab fa-twitter" />
                      </a>
                    )}
                    {tour.client?.website && (
                      <a
                        href={
                          tour.client?.website?.includes('https://')
                            ? tour.client.website
                            : `https://${tour.client?.website}`
                        }
                        rel="noreferrer"
                        target="_blank"
                      >
                        <i className="fas fa-globe-americas" />
                      </a>
                    )}
                    {((tour.tourEmail && tour.tourEmail.assertContactIcon) ||
                      (tour.client && tour.client.email)) && (
                      <a
                        href={
                          (tour.tourEmail?.assertContactIcon &&
                            `mailto:${tour.tourEmail.assertContactIcon}`) ||
                          `mailto:${tour.client.email}`
                        }
                        rel="noreferrer"
                        target="_blank"
                      >
                        <i className="fas fa-envelope" />
                      </a>
                    )}
                    {(tour.tourEmail?.contactPhone || tour.client?.phone) && (
                      <a
                        href={`
                          tel:${tour.tourEmail?.contactPhone || tour.client?.phone}`}
                        rel="noreferrer"
                        target="_blank"
                      >
                        <i className="fas fa-phone" />
                      </a>
                    )}
                  </div>
                )}
                <div className="overlay" />
              </div>
              <div className="clearfix" />
            </div>
          )}

          <div className="social">
            <h3>{tour.translation?.shareThisPage}</h3>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.facebook.com/dialog/share?app_id=${fbAppId || '741048509750318'}&display=popup&href=${encodeURIComponent(
                window.location.href,
              )}&redirect_uri=${encodeURIComponent(window.location.href)}`}
            >
              <i className="fab fa-facebook" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(window.location.href)}`}
            >
              <i className="fab fa-twitter" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}
            >
              <i className="fab fa-whatsapp" />
            </a>
            <a
              rel="noreferrer"
              target="_blank"
              href={`mailto:?body=${encodeURIComponent(window.location.href)}`}
            >
              <i className="fas fa-envelope" />
            </a>
          </div>

          <footer>
            <div className="container">
              <span>
                {tour.translation?.designedAndDevelopedBy}{' '}
                <a href={whitelabel?.website} rel="noreferrer" target="_blank">
                  <img src={whitelabel?.logo} alt="" />
                </a>
              </span>
            </div>
          </footer>
        </div>
        {tour && !tour.hideCookie && (
          <CustomCookieConsent
            tour={tour}
            loaded={false}
            message={tour.translation?.cookieConsentText}
            accept={tour.translation?.cookieConsentAccept}
            decline={tour.translation?.cookieConsentDecline}
            messageMandatoryTitle={tour.translation?.cookieConsentTextMandatoryTitle}
            messageMandatoryDescription={tour.translation?.cookieConsentTextMandatoryDescription}
            acceptMandatory={tour.translation?.cookieConsentAcceptMandatory}
            declineMandatory={tour.translation?.cookieConsentDeclineMandatory}
          />
        )}
      </div>
    );
  }
}
